<template>
  <a-form-field v-bind="formFieldAttrs">

    <template slot-scope="slotProps">

      <c-busy
        v-if="loadStatus === $config.status.LOADING"
        class="datepicker-loading"
      />

      <input
        ref="input"
        :aria-describedby="slotProps.describedby"
        :aria-invalid="hasError ? 'true' : 'false'"
        :disabled="loadStatus === $config.status.LOADING"
        :value="value"
        v-bind="$attrs"
        class="form-input"
      >

    </template>

  </a-form-field>
</template>

<script>
import BFormInput from '@/components/form/base/BFormInput'
import CBusy from '@/components/CBusy'
import AFormField from '@/components/form/atoms/AFormField'

import { German } from 'flatpickr/dist/l10n/de.js'

export default {
  name: 'CFormDatepicker',

  components: {
    AFormField,
    CBusy
  },

  extends: BFormInput,

  props: {
    altFormat: {
      type: String,
      default: 'd.m.Y'
    },
    disable: {
      type: Array,
      default () {
        return []
      }
    },
    enable: {
      type: Array,
      default () {
        return []
      }
    },
    maxDate: {
      type: [Date, String]
    },
    minDate: {
      type: [Date, String]
    },
    value: {
      type: String
    }
  },

  data () {
    return {
      loadStatus: this.$config.status.IDLE,
      datepicker: null
    }
  },

  watch: {
    id (value) {
      this.setAttributes()
    },
    value (value) {
      this.setDate(value)
    }
  },

  mounted () {
    this.loadStatus = this.$config.status.LOADING

    import('flatpickr')
      .then(({ default: flatpickr }) => {
        this.loadStatus = this.$config.status.SUCCESS

        // Wait for Vue to remove `disabled` form input
        this.$nextTick(() => {
          this.datepicker = flatpickr(this.$refs.input, {
            altFormat: this.altFormat,
            altInput: true,
            disable: this.disable,
            enable: this.enable,
            locale: German,
            maxDate: this.maxDate,
            minDate: this.minDate,
            onChange: (selectedDates, dateStr) => {
              this.$emit('input', dateStr)
            }
          })

          this.setAttributes()
        })
      })
      .catch(() => {
        this.loadStatus = this.$config.status.ERROR
      })
  },

  beforeDestroy () {
    this.datepicker.destroy()
    this.datepicker = null
  },

  methods: {
    setDate (value) {
      this.datepicker.setDate(value)
    },
    setAttributes () {
      if (this.datepicker.isMobile) {
        this.datepicker.mobileInput.id = this.id
      } else {
        this.datepicker.altInput.id = this.id
      }
    }
  }
}
</script>

<style src="flatpickr/dist/flatpickr.css"></style>

<style>
.datepicker-loading {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: var(--color-brand);
}

.flatpickr-day:hover,
.flatpickr-day:focus {
  background-color: var(--color-brand-pale);
  border-color: var(--color-brand-pale);
}

.flatpickr-day.today,
.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  border-color: var(--color-brand);
}

.flatpickr-day.today:hover,
.flatpickr-day.today:focus {
  color: inherit;
  background-color: var(--color-brand-pale);
}

.flatpickr-day.selected,
.flatpickr-day.selected:hover,
.flatpickr-day.selected:focus {
  color: #fff;

  background-color: var(--color-brand);
  border-color: var(--color-brand);
}
</style>
